module.exports = __webpack_public_path__ + "img/list-of-inclusions-icon.ea96871f.svg";